export default __webpack_public_path__ + "static/media/library_white_icon.fe96050e.svg";